
import { NewsComponent } from "../news/news.component"
import { NewsListComponent } from "../news/newslist.component"
import { LocalNavComponent } from "../local-nav.component"
import { DarkModeSwitcher } from '../dark-mode/dark-mode-switcher.component'
import { GlobalSearchComponent } from '../global-search/components/search/global-search.component'
import { AssetScreenerComponent } from '../assetScreener/components/assetScreener.component'
import { PaymentsComponent } from '../profile/Payments/Payments.component'
import { GlobalSearchOpener } from '../global-search/components/opener/global-search-opener.component'
import { SearchHitComponent } from '../global-search/components/search-hit/search-hit.component'
import { TokenDataContainer } from "../tokenData/components/tokenDataList"
import { TokenDataItem } from "../tokenData/components/tokenDataItem"
import { SigninComponent } from "../auth/components/signin/signin.component"
import { AuthState } from "../auth/components/auth-state.component"
import { NumberComponent } from "../numbers/number.component"
import { NewsletterManager } from "../newsletters/newsletter.component"
import { SignoutButtonComponent } from "../auth/components/signout/signout-btn.component"
import { ArticleAnchorsComponent } from "../content/articles/anchors/anchors.component"
import { ArticleReadingTimeComponent } from "../content/articles/reading-time/reading-time.component"

// import { ChartManager } from "../charts/charts.manager"
import { ArticlePremiumContent } from "../content/articles/text/premium-content.component"
import { ReportEmbed } from "../content/reports/embed.component"

const components = [
  // Auth
  { name: 'tbw-signin', component: SigninComponent },
  { name: 'tbw-auth-state', component: AuthState },
  { name: 'tbw-signout-btn', component: SignoutButtonComponent },

  // Dev
  { name: 'tbw-local-nav', component: LocalNavComponent },

  // News
  { name: 'tbw-news', component: NewsComponent },
  { name: 'tbw-news-list', component: NewsListComponent },

  // Token Data
  { name: 'tbw-token-data-container', component: TokenDataContainer },
  { name: 'tbw-token-data-item', component: TokenDataItem },

  // Design
  { name: 'tbw-dark-mode-switcher', component: DarkModeSwitcher },

  // Asset Screener
  { name: 'tbw-asset-screener', component: AssetScreenerComponent },

  // Payments
  { name: 'tbw-payments', component: PaymentsComponent },

  // Global Search
  { name: 'tbw-global-search-opener', component: GlobalSearchOpener },
  { name: 'search-hit', component: SearchHitComponent },
  { name: 'tbw-global-search', component: GlobalSearchComponent },

  // Newsletter
  { name: 'tbw-nl-manager', component: NewsletterManager },
  { name: 'tbw-number', component: NumberComponent },

  // Article Anchors
  { name: 'tbw-anchors', component: ArticleAnchorsComponent },
  { name: 'tbw-reading-time', component: ArticleReadingTimeComponent },
  { name: 'tbw-premium-content', component: ArticlePremiumContent },
  { name: 'tbw-report-embed', component: ReportEmbed }
]


export const registerComponents = () => {
  components.forEach(component => {
    customElements.define(component.name, component.component)
  })
}